import _ from 'lodash';
import * as Actions from 'redux/actions/index';

const initialState = {};

export default function researchReviews(state = initialState, action) {
  switch (action.type) {
    case Actions.LOAD_RESEARCH_SUBMISSION_REVIEWS: {
      return {
        ...state,
        [action.researchSubmissionId]: action.reviews,
      };
    }
    default:
      return state;
  }
}
